import angular = require("angular");
import TPL = require("templates");
import {SessionService} from "../../services/session";
import {Config} from "../../config";

export class ManageMenuItem {

  label: string;
  key: string;
  linkUrl: string;
  callback: () => void;
  orange: () => number;
  red: () => number;

  subMenu: ManageMenuItemList;

  static buildManageMenuItem(label, key, linkUrl, callback?, subMenu?, orange?, red?): ManageMenuItem {
    var result = new ManageMenuItem();
    result.label = label;
    result.key = key;
    result.linkUrl = linkUrl;
    result.callback = callback;
    result.subMenu = subMenu;
    result.orange = orange ? orange : () => 0;
    result.red = red ? red : () => 0;

    return result;
  }
}

export class ManageMenuItemList extends Array<ManageMenuItem> {

  constructor() {
    super();
  }

  static buildManageMenuItemList($location): ManageMenuItemList {
    var result = new ManageMenuItemList();

    var innerHosting = new ManageMenuItemList();

    innerHosting.push(ManageMenuItem.buildManageMenuItem(
      "MANAGE.HOSTED", Config.hosted, Config.linkHash + Config.manage + "/" + Config.hosted,
      ()=> {
        //$location.url(Config.manage + "/" + Config.hosted);
        //$location.replace();
      },
      null,
      ()=>0)
    );
    innerHosting.push(ManageMenuItem.buildManageMenuItem(
      "MANAGE.SAVED", Config.saved, Config.linkHash + Config.manage + "/" + Config.saved,
      ()=> {
        //$location.url(Config.manage + "/" + Config.saved);
        //$location.replace();
      },
      null,
      ()=>0,
      ()=>0)
    );
    innerHosting.push(ManageMenuItem.buildManageMenuItem(
      "MANAGE.PAST", Config.past, Config.linkHash + Config.manage + "/" + Config.past,
      ()=> {
        //$location.url(Config.manage + "/" + Config.past);
        //$location.replace();
      },
      null,
      ()=>0,
      ()=>0)
    );

    result.push(ManageMenuItem.buildManageMenuItem(
      "MANAGE.HOSTING", null, null, null, innerHosting));

    result.push(ManageMenuItem.buildManageMenuItem(
      "MANAGE.UPCOMING",
      Config.upcoming,  Config.linkHash + Config.manage + "/" + Config.upcoming,
      ()=> {
        //$location.url(Config.manage + "/" + Config.upcoming);
        //$location.replace();
      },
      null,
      ()=> 0,
      ()=> 0)
    );

    return result;
  }
}


export class ManageMenuDirective {

  template = TPL.contentDirectives.manageMenu;
  scope = {
    params: "=params"
  };
  link;


  constructor($location, $routeParams, $modal, session: SessionService) {

    this.link = (scope, el, attrs) => {
        scope.vm = {
          menuItemList: ManageMenuItemList.buildManageMenuItemList($location),
          current: $routeParams.what,
          openCreatePage: () => {
            $location.path(Config.events);
            $location.replace();
          }
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d) => new ManageMenuDirective(a, b, c, d);
    tmp.$inject = ["$location", "$routeParams", "$uibModal", "session"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/manageMenu.ts
 **/